<template>
    <div class="contentHome">
        <div class="centerPage">
            <el-tabs v-model="activeName" class="tabs" @tab-click="changeTab">

                <el-tab-pane name="all" label="全部">
                    <div v-if="topConsultation.id" class="newCon img" :style="'backgroundImage: url('+topConsultation.thumbnailPath+')'">
                        <h1 class="overflow">{{topConsultation.title}}</h1>
                        <p class="overflow">{{topConsultation.subTitle}}</p>
                        <el-button size="mini" @click="toDetail(topConsultation.id,0)">期待您的加入</el-button>
                    </div>
                    <div class="mineCon flex ">
                        <div class="drug " v-for="(obj ,ind) in consultations" :key="ind">
                            <div :style="'backgroundImage: url('+obj.thumbnailPath+')'" class="img "></div>
                            <div class="rightC">
                                <h3 class="overflow">{{obj.title}}</h3>
                                <p class="overflow">{{obj.subTitle}}</p>
                                <el-button size="mini" class="consultationIn" @click="toDetail(obj.id,0)">期待您的加入</el-button>
                            </div>
                        </div>
                        <div class="empty" v-if="consultations.length===0">
                            <img src="../../assets/img/no.png" alt="" width="200">
                            <p>这里什么都没有</p>
                        </div>
                    </div>
                </el-tab-pane>

                <el-tab-pane name="me" label="我的" class="mineCon flex " v-if="getUserId">
                    <div class="drug " v-for="(obj ,ind) in myConsultations" :key="ind">
                        <div :style="'backgroundImage: url('+obj.thumbnailPath+')'" class="img "></div>
                        <div class="rightC">
                            <h3 class="overflow">{{obj.title}}</h3>
                            <p class="overflow">{{obj.subTitle}}</p>
                            <el-button size="mini"
                                       @click="toDetail(obj.id,1)"
                                       :class="obj.conState==0?'registered':obj.conState==1?'consultationIn':'over'">
                                {{obj.stateText}}
                            </el-button>
                        </div>
                    </div>
                    <div class="empty" v-if="consultations.length===0">
                        <img src="../../assets/img/no.png" alt="" width="200">
                        <p>这里什么都没有</p>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <el-input class="addART"
                      placeholder="搜索会诊名称"
                      @change="skipPage(1)"
                      v-model="page.name" suffix-icon="el-icon-search">
            </el-input>
            
            
            <div style="text-align: center">
                <el-pagination
                        class="pagination"
                        :hide-on-single-page="true"
                        background
                        prev-text="Prev"
                        next-text="Next"
                        @current-change="skipPage"
                        :current-page="page.current"
                        :page-size="page.size"
                        layout="prev, pager, next"
                        :total="page.total">
                </el-pagination>
            </div>

        </div>
    </div>
</template>

<script>
    import base from '@/api/common';
    export default {
        name: "consultation",
        data() {
            return {
                activeName: 'all',
                tabName: 'all',
                loadCount: 0, //首次加载时将首个会议置顶放大
                topConsultation:{},
                consultations:[{}],
                myConsultations:[{}],
                page:{
                    name: '',
                    current: 1,
                    size: 8,
                    total: 15,
                },

                getUserId: '',//当前用户id
            }
        },
        async mounted() {
            //load mine
            this.getData();
            let currentUser = await base.utils.getCurrent();//获取当前登录的用户id
            if (currentUser != null) {
                this.getUserId = currentUser.id;
            }
        },
        methods:{
            changeTab(tab){
                // 防止重复请求数据
                if(tab.name === this.tabName){
                    return;
                }
                this.tabName = tab.name;
                this.page.current = 1;
                this.getData(()=>{
                    this.loadCount++;
                });
            },
            getData(callbackFn){
                let url,callback;
                if(this.activeName === 'me'){
                    url = base.api.expert.consultation.list_me;
                    callback = (rows)=>{
                        $(rows).each((i,o)=>{
                            this.conStateFmt(o);
                        });
                        this.myConsultations = rows;
                    };
                }else{
                    url = base.api.expert.consultation.list_all;
                    callback = (rows)=>{
                        this.consultations = rows;
                        if(this.loadCount === 0 && rows.length >0){
                            this.topConsultation = rows[0];
                        }
                    };
                }
                this.$ajax.get(url,{params:{
                        page: this.page.current,
                        size: this.page.size,
                        name: this.page.name,
                    }}).then((res)=>{
                    if(res.data.status === 'success'){
                        this.page.current = res.data.current;
                        this.page.size = res.data.size;
                        this.page.total = res.data.total;
                        callback(res.data.rows);
                        if(callbackFn){
                            callbackFn();
                        }
                    }
                })
                //document.querySelector('.homeIndex').scrollTop = 0;//回到顶部
            },
            skipPage(cur){
                this.page.current = cur;
                this.getData();
                this.$nextTick(() => {
                    $(".contentIndex").animate({scrollTop: '0px'}, 800);
                });
            },
            conStateFmt(item){
                if(!item || !item.id){
                    return;
                }
                let s = new Date(item.meetStartDate.replace(/-/g,"/"));
                let e = new Date(item.meetEndDate.replace(/-/g,"/"));
                let de = new Date(item.deadlineDate.replace(/-/g,"/"));
                let cur = new Date();

                if(e.getTime() <= cur.getTime()){
                    item.conState = 2;
                    item.stateText = "已结束";
                    return;
                }
                if(s.getTime() > cur.getTime()){
                    item.conState = 0;
                    item.stateText = "已报名";
                    return;
                }
                if(s.getTime()<= cur.getTime() && e.getTime() > cur.getTime()){
                    item.conState = 1;
                    item.stateText = "会诊中";
                    return;
                }
                item.conState = 2;
                item.stateText = "已结束";
            },
            toDetail(id,state){
                this.$router.push({name: 'consultationDetail',query:{id:id,state:state}});
            }
        },
    }
</script>

<style scoped lang="scss">
@import '../../assets/css/medication.scss';
</style>